import { Button } from '@mui/material';
import { trackingPrint } from '@app/model';
import { useState } from 'react';
import { InviteContactDialog } from '@src/components/dialogs/InviteContactDialog';

interface InviteEmergencyContactButtonProps {
  onInviteClick?: () => void;
}

export const InviteEmergencyContactButton = ({ onInviteClick }: InviteEmergencyContactButtonProps) => {
  const [openInviteDialog, setOpenInviteDialog] = useState(false);

  const handleClick = () => {
    // 邀请紧急联系人按钮点击埋点
    trackingPrint({
      params: {
        type: "用户操作",
        title: "联系人管理",
        subtitle: "邀请联系人-按钮点击",
        extra: {
          timestamp: Date.now(),
          page: "home"
        }
      }
    });
    
    setOpenInviteDialog(true);
    onInviteClick?.();
  };

  return (
    <>
      <Button
        variant="contained"
        fullWidth
        onClick={handleClick}
        sx={{
          backgroundColor: '#4CAF50',
          color: 'white',
          fontSize: '16px',
          fontWeight: 'bold',
          minHeight: '48px',
          borderRadius: '24px',
          boxShadow: '0 4px 16px rgba(76, 175, 80, 0.3)',
          textTransform: 'none',
          position: 'relative',
          overflow: 'hidden',
          '&:hover': {
            backgroundColor: '#45a049',
            transform: 'translateY(-1px)',
            boxShadow: '0 6px 20px rgba(76, 175, 80, 0.4)',
          },
          '&:active': {
            transform: 'translateY(0px)',
            boxShadow: '0 2px 8px rgba(76, 175, 80, 0.3)',
          },
        }}
      >
        邀请联系人
      </Button>
      
      <InviteContactDialog 
        open={openInviteDialog} 
        onClose={() => {
                  // 邀请联系人对话框关闭埋点
                  trackingPrint({params:{
                    type:"模态框操作",
                    title:"联系人管理",
                    subtitle:"邀请对话框-关闭",
                    extra:{
                      timestamp: Date.now(),
                      page: "home"
                    }
                  }});
                  setOpenInviteDialog(false);
                }}
      />
    </>
  );
};
